import { LuLockKeyhole } from '@platform/icon';
import { FormField } from '@/shared/ui';
import type { CheckoutOrderer } from '../../model/education-checkout.type';

interface CheckoutOrdererSectionProps {
  orderer: CheckoutOrderer;
  /** 계정 값으로 잠겨 있는지. 수정하기를 누르면 풀린다. */
  locked: boolean;
  editing: boolean;
  disabled: boolean;
  onChange: (patch: Partial<CheckoutOrderer>) => void;
  onEdit: () => void;
  onReset: () => void;
}

/** 개인 접수의 신청자 정보 — 계정 값으로 채워 두고, 필요할 때만 풀어서 고친다. */
export function CheckoutOrdererSection({
  orderer,
  locked,
  editing,
  disabled,
  onChange,
  onEdit,
  onReset,
}: CheckoutOrdererSectionProps) {
  return (
    <section
      className="overflow-hidden rounded-lg border border-gray-200 bg-white dark:border-white/10 dark:bg-transparent"
      aria-labelledby="orderer-heading"
    >
      <div className="flex flex-wrap items-end justify-between gap-3 border-b border-gray-200 bg-gray-50/70 px-5 py-4 dark:border-white/10 dark:bg-white/[0.03]">
        <div>
          <h2
            id="orderer-heading"
            className="text-base font-semibold text-gray-950 dark:text-neutral-100"
          >
            신청자 정보
          </h2>
          <p className="mt-1 inline-flex items-center gap-1.5 text-xs text-gray-500 dark:text-neutral-400">
            <LuLockKeyhole aria-hidden className="h-3.5 w-3.5" />
            계정 정보가 자동으로 입력되었습니다.
          </p>
        </div>
        {editing ? (
          <button
            type="button"
            onClick={onReset}
            className="rounded-sm text-xs font-semibold text-brand-700 underline underline-offset-4 hover:text-brand-800 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-500 dark:text-brand-300 dark:hover:text-brand-200"
          >
            계정 정보로 되돌리기
          </button>
        ) : (
          <p className="text-xs text-gray-500 dark:text-neutral-400">
            신청자 정보가 다른가요?{' '}
            <button
              type="button"
              onClick={onEdit}
              className="rounded-sm font-semibold text-brand-700 underline underline-offset-4 hover:text-brand-800 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-500 dark:text-brand-300 dark:hover:text-brand-200"
            >
              수정하기
            </button>
          </p>
        )}
      </div>
      <fieldset disabled={disabled} className="grid gap-4 p-5 sm:grid-cols-2">
        <FormField
          required
          label="신청자명"
          name="ordererName"
          readOnly={locked}
          value={orderer.ordererName}
          onChange={(event) => onChange({ ordererName: event.target.value })}
        />
        <FormField
          required
          label="연락처"
          name="ordererPhone"
          readOnly={locked}
          inputMode="tel"
          placeholder="010-0000-0000"
          value={orderer.ordererPhone}
          onChange={(event) => onChange({ ordererPhone: event.target.value })}
        />
        <FormField
          required
          type="email"
          label="이메일"
          name="ordererEmail"
          readOnly={locked}
          value={orderer.ordererEmail}
          onChange={(event) => onChange({ ordererEmail: event.target.value })}
        />
      </fieldset>
    </section>
  );
}
